// extracted by mini-css-extract-plugin
export default {"formHeader":"FormHeader_formHeader__uD11C"};